import { motion, AnimatePresence } from 'framer-motion';
import { Z_PLAYER_HUD } from '../../../features/quickstart/config/zIndexLayers';

interface AfkOverlayProps {
  visible: boolean;
  remainingSeconds: number;
  totalSeconds: number;
}

const PULSE_DURATION = 2.5; // seconds per pulse cycle

const formatTime = (seconds: number): string => {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins}:${secs.toString().padStart(2, '0')}`;
};

/**
 * Full-screen AFK overlay rendered on top of the player during in-game idle.
 *
 * - Pulsing black vignette around screen edges
 * - pointer-events: none so the gamepad underneath remains interactive
 */
export const AfkOverlay = ({ visible, remainingSeconds, totalSeconds }: AfkOverlayProps) => {
  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          key="afk-overlay"
          className="pointer-events-none fixed inset-0"
          style={{ zIndex: Z_PLAYER_HUD }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.35 }}
        >
          {/* Pulsing black vignette */}
          <div
            className="absolute inset-0"
            style={{
              animation: `afk-vignette-pulse ${PULSE_DURATION}s ease-in-out infinite`,
            }}
          />

          {/* Inline keyframes (injected once) */}
          <style>{`
            @keyframes afk-vignette-pulse {
              0%, 100% {
                box-shadow: inset 0 0 8vw 4vw rgba(0, 0, 0, 0.85);
              }
              50% {
                box-shadow: inset 0 0 14vw 7vw rgba(0, 0, 0, 0.95);
              }
            }
          `}</style>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
